export const SELECT_TOP_STORIES  = 'SELECT_TOP_STORIES';
export const TOP_STORIES_START   = 'TOP_STORIES_START';
export const TOP_STORIES_SUCCESS = 'TOP_STORIES_SUCCESS';
export const TOP_STORIES_FAILURE = 'TOP_STORIES_FAILURE';

export const MOST_POPULAR_START   = 'MOST_POPULAR_START';
export const MOST_POPULAR_SUCCESS = 'MOST_POPULAR_SUCCESS';
export const MOST_POPULAR_FAILURE = 'MOST_POPULAR_FAILURE';


export const ARTICLE_SEARCH_INPUT   = 'ARTICLE_SEARCH_INPUT';
export const ARTICLE_SEARCH_START   = 'ARTICLE_SEARCH_START';
export const ARTICLE_SEARCH_SUCCESS = 'ARTICLE_SEARCH_SUCCESS';
export const ARTICLE_SEARCH_FAILURE = 'ARTICLE_SEARCH_FAILURE'; 

export const ARTICLE_CHANGE_PAGE_START    = 'ARTICLE_CHANGE_PAGE_START';
export const ARTICLE_CHANGE_PAGE_SUCCESS  = 'ARTICLE_CHANGE_PAGE_SUCCESS';
export const ARTICLE_CHANGE_PAGE_FAILED   = 'ARTICLE_CHANGE_PAGE_FAILED';

export const ANALYTICS_START   = 'ANALYTICS_START';
export const ANALYTICS_SUCCESS = 'ANALYTICS_SUCCESS';
export const ANALYTICS_FAILED  = 'ANALYTICS_FAILED';

export const ANALYTICS_DETAILS_START   = 'ANALYTICS_DETAILS_START';
export const ANALYTICS_DETAILS_SUCCESS = 'ANALYTICS_DETAILS_SUCCESS';
export const ANALYTICS_DETAILS_FAILURE = 'ANALYTICS_DETAILS_FAILURE';



// WEBPACK FOOTER //
// ./src/Store/actions/actionTypes.js